<template>
    <div>
        <b-card no-body>
            <loading :active.sync="isLoading" loader="spinner" color="#20A8D8" :is-full-page="false" />
            <b-tabs card>
                <b-tab title="Change Logs" active>
                    <b-card>
                        <b-row>
                            <b-col sm="6" md="3" class="mb-2 d-flex flex-column">
                                <b>Change Logs</b>
                                <small class="text-muted sub">Recent update logs</small>
                            </b-col>
                            <b-col sm="6" md="4" offset-md="5" class="mb-2 text-md-right">
                                <b-input-group prepend="Show" append="/ Page">
                                    <b-form-select :options="pageOptions" v-model="perPage" />
                                </b-input-group>
                            </b-col>
                        </b-row>
                        <b-table show-empty striped hover :items="items" :fields="fields" :current-page="currentPage"
                            :per-page="perPage" :filter="filter" :sort-by.sync="sortBy" :sort-desc.sync="sortDesc"
                            :sort-direction="sortDirection" responsive>
                            <template v-slot:cell(dateCreated)="row">
                                {{ showFormattedDate(row.item.dateCreated) }}
                            </template>
                            <template v-slot:cell(totalDiscrepancies)="row">
                                {{
                                    (getAssetDetails(row.item.new).adjustedTotal || 0) -
                                    (getAssetDetails(row.item.new).currentTotal || 0)
                                }}
                            </template>
                            <template v-slot:cell(currentTotal)="row">
                                {{ getAssetDetails(row.item.new).currentTotal }}
                            </template>
                            <template v-slot:cell(adjustedTotal)="row">
                                {{ getAssetDetails(row.item.new).adjustedTotal }}
                            </template>
                            <template v-slot:cell(remarks)="row">
                                {{ getAssetDetails(row.item.new).remarks }}
                            </template>
                            <template v-slot:cell(updatedBy)="row">
                                {{ row.item.updatedBy }}
                            </template>
                        </b-table>

                        <b-row>
                            <b-col md="8" sm="12" class="my-1">
                                <span class="total-display">
                                    Total: {{ totalRows ? totalRows.toLocaleString() : 0 }}
                                </span>
                            </b-col>
                            <b-col md="4" sm="12" class="my-1">
                                <b-pagination align="right" :total-rows="totalRows" :per-page="perPage"
                                    v-model="currentPage" class="my-0" />
                            </b-col>
                        </b-row>

                        <b-row class="mt-4 mb-2">
                            <b-col sm="12" class="text-sm-right">
                                <b-button size="sm" @click="row.toggleDetails" variant="secondary"
                                    v-b-tooltip.hover.top="'Hide Details'">
                                    <i class="icon-arrow-up"></i>
                                </b-button>
                            </b-col>
                        </b-row>
                    </b-card>
                </b-tab>
            </b-tabs>
        </b-card>
    </div>
</template>

<script>
// Utils
import { DateUtil } from '@/utils/dateutil';

// DAO
import AuditTrailLogsDAO from '@/database/auditTrailLogs';

// Others
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import truncate from 'vue-truncate-collapsed';
import _ from 'lodash';

export default {
    name: 'discrepancy-report-details-view',
    components: {
        Loading,
        truncate
    },
    props: {
        row: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            items: [],
            fields: [
                {
                    key: 'dateCreated',
                    label: 'Date Updated',
                    sortable: true,
                },
                {
                    key: 'totalDiscrepancies',
                    label: 'Total Discrepancies',
                    sortable: true,
                },
                {
                    key: 'currentTotal',
                    label: 'Current Total',
                    sortable: true,
                },
                {
                    key: 'adjustedTotal',
                    label: 'Adjusted Total',
                    sortable: true,
                },
                {
                    key: 'remarks',
                    label: 'Remarks',
                    sortable: true,
                },
                {
                    key: 'createdBy',
                    label: 'Updated By',
                    sortable: true,
                },
            ],

            currentPage: 1,
            perPage: 5,
            totalRows: 0,
            pageOptions: [5, 10, 15, 25, 50, 100],
            sortBy: null,
            sortDesc: false,
            sortDirection: 'asc',
            filter: null,

            selAssetTypeId: null,

            loggedUser: this.$store.getters.loggedUser,

            // Check for loader
            isLoading: false,
        };
    },
    async mounted() {
        const { id, assetTypeId } = this.row.item;
        this.selAssetTypeId = assetTypeId;
        await this.retrieveChangeLog(id, assetTypeId);
    },
    methods: {
        async retrieveChangeLog(id, assetTypeId) {
            if (id) {
                this.isLoading = true;

                let param = {
                    collection: 'dispatches',
                    id: id,
                };

                let results = await AuditTrailLogsDAO.getAuditTrailLogs(param);
                this.items = Object.values(results);
                this.items = this.items.filter(x => x.new.assets.some(y => y.assetTypeId === assetTypeId && y.discrepancies > 0))
                this.totalRows = this.items.length;

                this.isLoading = false;
            }
        },
        showFormattedDate(date) {
            return DateUtil.getFormattedDateWithTime(date);
        },
        getAssetDetails(newObj) {
            const asset = _.find(newObj.assets, x => x.assetTypeId === this.selAssetTypeId);

            return asset;
        }
    },
};
</script>

<style>
.sub {
    font-style: italic;
}
</style>